import { Property } from '../../../../api/Property';
import { TourPage, tourSignupPath, TourSignupProps, PropertyContext } from './TourRouter';
import { useContext } from 'react';
import * as React from 'react';
import { IdVerificationTypes } from '../../../../api/IdVerification';

const calculateNextPage = (current: TourPage) => (property: Property) => {
    if (current === TourPage.GuestCard) {
        if (property.idVerificationType !== IdVerificationTypes.None) {
            return TourPage.IdVerification;
        }

        current = TourPage.IdVerification;
    }

    if (current === TourPage.IdVerification) {
        if (property.requestCreditCard) {
            return TourPage.CcQualification;
        }

        return TourPage.Confirmation;
    }

    if (current === TourPage.CcQualification || current === TourPage.Confirmation) {
        return TourPage.Confirmation;
    }

    return TourPage.GuestCard;
};

const tourSignupChangePath = (props: TourSignupProps) =>
    tourSignupPath(props.match.params.propertySlug, props.match.params.guestCardGuid);

const tourNavigate = (
    props: TourSignupProps,
    caclulateFn: (property: Property) => TourPage,
    property?: Property,
    queryString?: string,
    guestCardGuid?: string
) => {
    if (!property) {
        return;
    }
    let lastPage = caclulateFn(property);
    let passProps: TourSignupProps = guestCardGuid
        ? {
              ...props,
              match: {
                  ...props.match,
                  params: { ...props.match.params, guestCardGuid: guestCardGuid }
              }
          }
        : props;
    props.history.push(`${tourSignupChangePath(passProps)(lastPage)}?${queryString || ''}`);
};

export const useTourNavigation = (current: TourPage, props: TourSignupProps) => {
    const property = useContext(PropertyContext);

    let goForward = (guestCardGuid?: string, queryString?: string) =>
        tourNavigate(props, calculateNextPage(current), property, queryString, guestCardGuid);
    return goForward;
};

export const TourNavigationButtons = (props: {
    page: TourPage;
    props: TourSignupProps;
    hideNext?: boolean;
}) => {
    const goForward = useTourNavigation(props.page, props.props);

    return (
        <div className="navigation-buttons">
            <button
                hidden={props.hideNext}
                className="btn btn-primary font-weight-bold mb-4"
                type="button"
                onClick={() => goForward()}
            >
                Next
            </button>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/TourStateMachine.tsx